export default async function init() {
  const businessEls = document.querySelectorAll('[data-js-module="business"]');

  const initBusiness = async () => {
    const { default: Business } = await import(/* webpackChunkName: "business" */ './business');
    businessEls.forEach((business) => new Business(business));
  };

  if (businessEls.length) initBusiness();
}

init();
